import React, { useState } from 'react';
import { Sparkles } from 'lucide-react';
import { candidatesApi, AIReferenceEvaluation } from '../../api/candidates';
import AIEvaluationModal from './AIEvaluationModal';

interface EvaluateWithAIButtonProps {
  candidateId: string;
  candidateName: string;
}

const EvaluateWithAIButton: React.FC<EvaluateWithAIButtonProps> = ({
  candidateId,
  candidateName
}) => {
  const [loading, setLoading] = useState(false);
  const [evaluation, setEvaluation] = useState<AIReferenceEvaluation | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleEvaluate = async () => {
    if (loading) return;
    
    setLoading(true);
    setError(null);
    
    try {
      const result = await candidatesApi.evaluateWithAI(candidateId);
      setEvaluation(result);
      setModalOpen(true);
    } catch (err) {
      console.error('Failed to evaluate candidate with AI:', err);
      setError('Failed to generate AI evaluation. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={handleEvaluate}
        disabled={loading}
        className="flex items-center gap-1.5 px-3 py-1.5 bg-indigo-50 hover:bg-indigo-100 text-indigo-600 text-sm font-medium rounded-md transition-colors disabled:opacity-50"
      >
        {loading ? (
          <span className="h-4 w-4 border-2 border-indigo-600 border-t-transparent rounded-full animate-spin"/>
        ) : (
          <Sparkles className="h-4 w-4" />
        )}
        {loading ? 'Analyzing...' : 'Evaluate with AI'}
      </button>
      
      {error && (
        <div className="mt-2 text-sm text-red-500">
          {error}
        </div>
      )}
      
      {evaluation && (
        <AIEvaluationModal
          evaluation={evaluation}
          candidateName={candidateName}
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
};

export default EvaluateWithAIButton;